
export class ElementClassManager {
    addClass = (selector: string, className: string) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((element) => element.classList.add(className));
    }

    removeClass = (selector: string, className: string) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach((element) => element.classList.remove(className));
    }
}
